import { dollars, dollarsToNum, LoanApplication, PreSubmitStatusOrder } from "@oneethos/shared"
import { ConsumerAppFormData } from "."

export const formDataToLoanApp = (formData): LoanApplication => {
  const { ...lapp } = formData

  lapp.customerName = `${lapp.firstName} ${lapp.lastName}`
  if (typeof lapp.loanAmount === 'string') {
    lapp.loanAmount = dollarsToNum(lapp.loanAmount)
  }

  if (typeof lapp.avgMonthlyUtilityBill === 'string') {
    lapp.avgMonthlyUtilityBill = dollarsToNum(lapp.avgMonthlyUtilityBill)
  }

  return lapp
}

export const lappToFormData = (lapp: LoanApplication): Partial<ConsumerAppFormData> => {
  return {
    preSubmitStatus: PreSubmitStatusOrder[0],
    // important to initialize these to false to prevent false approvals
    agreesToTermsAndConditions: false,
    agreesToProceedWithHardCreditInquiry: false,
    installedAtDifferentLocation: 'no',
    useAutoDebit: 'yes',
    ...lapp,
    incentive: parseFloat(lapp.incentive?.estPriceWithIncentives) > 0 ? lapp.incentive : undefined,
    loanAmount: dollars(lapp.loanAmount?.toString() || ''),
    solarCost: dollars(lapp.solarCost?.toString()),
    adders: lapp.adders?.map(adder => ({
      ...adder,
      amount: dollars(adder.amount?.toString())
    })),
    avgMonthlyUtilityBill: (
      lapp.avgMonthlyUtilityBill ?
        dollars(lapp.avgMonthlyUtilityBill?.toString()) :
        undefined
    )
  }
}
